import { useForm } from '@tanstack/react-form';
import { RegisterMembershipInput, RegisterMembershipInputSchema } from '../api/register-membership';
import { FormFooterProps, FormProps } from '@/types/form/form-props';
import { fieldToInputProps, toFormProps } from '@/utils/shared/form';
import CardSwitchInput from '@/shared/components/ui/inputs/card-switch-input';
import { MembershipRole } from '@/types/api/membership';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';
import { Flame } from 'lucide-react';

const PARTIICPATE_LABEL = 'Delta själv i gruppens försäljning';
const PARTIICPATE_DESC = 'Genom att delta kan du utöver att leda gruppen även vara med själv och sälja.';

export function RegisterMembershipForm({
  onSubmit,
  defaultValues,
  Footer = RegisterMembershipFormFooter,
  roles,
  ...rest
}: FormProps<RegisterMembershipInput> & { roles: MembershipRole[] }) {
  const form = useForm({
    defaultValues,
    validators: { onSubmit: RegisterMembershipInputSchema },
    onSubmit: ({ value }) => onSubmit(value),
  });

  return (
    <form {...toFormProps(form)} {...rest}>
      {roles.includes(MembershipRole.Leader) && (
        <form.Field name="participate">
          {(field) => (
            <CardSwitchInput {...fieldToInputProps(field, PARTIICPATE_LABEL)} description={PARTIICPATE_DESC} />
          )}
        </form.Field>
      )}

      <form.Subscribe selector={(s) => [s.canSubmit, s.isSubmitting]}>
        {([canSubmit, isSubmitting]) => <Footer canSubmit={canSubmit} isSubmitting={isSubmitting} />}
      </form.Subscribe>
    </form>
  );
}

function RegisterMembershipFormFooter({ canSubmit, isSubmitting }: FormFooterProps) {
  return (
    <div className="flex w-full justify-end">
      <LoadingButton disabled={!canSubmit} isLoading={isSubmitting} type="submit" className="flex-1">
        <Flame />
        Gå med i grupp
      </LoadingButton>
    </div>
  );
}
